/**
 * サジェストURLを生成する
 * @param 駅コード
 * @returns ランキングURL
 */
function createSuggestListURL(station_cd){
	// ランキング基本URLを取得
	var url = $('input[name=ranking_base_url]').val();
	// 口コミカテゴリがある場合
	if ($('input[name=rank_category]').val()) {
		station_cd += 'c' + $('input[name=rank_category]').val();
	}
	// 小学生ランキングの場合、学年カテゴリを空にする
	// ※小学生ランキングは学年カテゴリコードを許容しているためリンクに誤って付与されることを防ぐため
	if ($('input[name=ranking_type]').val() == 'rankJuniorSchool') {
		$('input[name=grade_category]').val('');
	}
	// ランキングURLに駅コード付与
	url += 's' + station_cd + '.html';
	// 学年コードがある場合リンクに付与
	if ($('input[name=grade]').val()) {
		url += '?grade=' + $('input[name=grade]').val();
	} else if ($('input[name=grade_category]').val()) {
		url += '?grade_category=' + $('input[name=grade_category]').val();
	}
	return url;
}